export const routes = {
  root: '/',
  reports: '/reports',
  login: '/login',
  scrapers: '/scrapers',
  searchByBranches: '/search-by-branches',
  stats: '/stats',
  rejectedReports: '/rejected-reports',
};
